import React from 'react';
//import InventoryValueDashboard from '../../../InventoryValue/InventoryValueDashboard';
//import InventoryValueDescription from '../../../InventoryValue/InventoryValueDescription';
import UsageTransferDashboard from '../../../UsageTransfer/UsageTransferDashboard';
import UsageTransferDescription from '../../../UsageTransfer/UsageTransferDescription';

type ReportRoute = {
    title: string;
    Component: React.FC<any>;
    Description?: React.FC<any>;
    qSightReportId: number;
};

export const reportsRoutesData: Record<string, ReportRoute> = {
    // 'inventory-value': {
    //     title: 'Inventory Value',
    //     Component: InventoryValueDashboard,
    //     Description: InventoryValueDescription,
    //     qSightReportId: 144
    // },
    'usage-transfer': {
        title: 'Usage Transfer',
        Component: UsageTransferDashboard,
        Description: UsageTransferDescription,
        qSightReportId: 194
    }
};

export default reportsRoutesData;